'use client';

import React from 'react';
import './ExecutionStatusRow.scss';
import { Loader2, CheckCircle2, AlertCircle, Play } from 'lucide-react';

interface ExecutionStatusRowProps {
    status: string;
    isExecuting: boolean;
    lastExecutionTime?: number;
    avgExecutionTime?: number;
    fcLoaded?: boolean;
    stepsCount?: number;
}

const ExecutionStatusRow: React.FC<ExecutionStatusRowProps> = ({
    status,
    isExecuting,
    lastExecutionTime = 0,
    avgExecutionTime = 0,
    fcLoaded,
    stepsCount,
}) => {
    const isError = status.toLowerCase().includes('error');
    const isSuccess = status.toLowerCase().includes('success') || status.toLowerCase().includes('completed');

    let statusClass = 'status-idle';
    if (isExecuting) statusClass = 'status-executing';
    else if (isError) statusClass = 'status-error';
    else if (isSuccess) statusClass = 'status-success';

    return (
        <div className={`execution-status-row ${statusClass}`}>
            <div className="status-main">
                <div className="status-icon">
                    {isExecuting ? (
                        <Loader2 className="animate-spin" size={14} />
                    ) : isError ? (
                        <AlertCircle size={14} />
                    ) : isSuccess ? (
                        <CheckCircle2 size={14} />
                    ) : (
                        <Play size={14} />
                    )}
                </div>
                <span className="status-text">{status}</span>
            </div>

            <div className="status-metrics">
                {lastExecutionTime > 0 && (
                    <div className="metric">
                        <span className="label">Time:</span>
                        <span className="value">{lastExecutionTime.toFixed(0)}ms</span>
                        {avgExecutionTime > 0 && <span className="sub-value">({avgExecutionTime.toFixed(0)}ms avg)</span>}
                    </div>
                )}

                {fcLoaded !== undefined && (
                    <div className="metric">
                        <span className="label">FC:</span>
                        <span className={`value ${fcLoaded ? 'text-success' : 'text-error'}`}>
                            {fcLoaded ? 'Ready' : 'Not Loaded'}
                        </span>
                    </div>
                )}

                {typeof stepsCount === 'number' && (
                    <div className="metric">
                        <span className="label">Steps:</span>
                        <span className="value">{stepsCount}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExecutionStatusRow;
